// Central source of truth for organisation contact + brand assets.
// Update here, and the change ripples through Navbar, Footer, Contact, Donate, policies.

export const SEEDH = {
    name: "Seedh Welfare Society",
    /** Full registered name — "Udaipur" is part of it, not just the location.
     *  Used on formal documents such as certificates. */
    legalName: "Seedh Welfare Society Udaipur",

    /** Signatory on issued certificates. `signatureImage` lives in /public; if
     *  it is missing the certificate still prints the rule and the name. */
    signatory: {
        name: "Sonali Soni",
        title: "President",
        signatureImage: "/signature-president.png",
    },
    tagline: "The Route Ahead",
    city: "Udaipur, Rajasthan",

    email: "seedhwelfaresociety@gmail.com",
    phone: "+91 91191 96280",
    phoneDigits: "+919119196280",

    addressLines: [
        "20, 100ft Road, Shobhagpura",
        "Udaipur, Rajasthan, India",
    ],
    addressOneLine: "20, 100ft Road, Shobhagpura, Udaipur, Rajasthan",

    // Social — placeholder until provided
    instagram: "https://instagram.com",

    // Donations — UPI placeholder until provided
    upiId: "7340510611@sbi",

    // Brand logo. Served locally from frontend/public so it never depends on an
    // external host. Drop your real logo in public/ and update these paths.
    logoLight: "/seedh-logo.png",
    logoDark: "/seedh-logo.png",
};
